import React, { useContext } from 'react';
import classnames from 'classnames';
import { TabContent, Option } from './types';
import { WalletSortAndFilterContext } from './context';
import { OutlinedButton } from 'components/outlined-btn/OutlinedButton';
import { allCards, eGift, reload } from './util';

export const CardTypeTab = ({ isActive }: TabContent) => {
    const { activeCardTypeFilter, setActiveCardTypeFilter, resolveCardTypeActiveFilters } =
        useContext(WalletSortAndFilterContext);

    const setActiveCardType = (cardType: Option) => {
        const updatedFilters: Set<Option> = resolveCardTypeActiveFilters(cardType);

        setActiveCardTypeFilter(updatedFilters);
    };

    return (
        <div className={classnames('flex justify-around mt-7', isActive ? '' : 'hidden')}>
            <OutlinedButton
                active={activeCardTypeFilter.has(allCards)}
                onClick={() => setActiveCardType(allCards)}
            >
                {allCards.text}
            </OutlinedButton>
            <OutlinedButton
                active={activeCardTypeFilter.has(eGift)}
                onClick={() => setActiveCardType(eGift)}
            >
                {eGift.text}
            </OutlinedButton>
            <OutlinedButton
                active={activeCardTypeFilter.has(reload)}
                onClick={() => setActiveCardType(reload)}
            >
                {reload.text}
            </OutlinedButton>
        </div>
    );
};
